import React from 'react'
import PropTypes from 'prop-types'
import { Edit } from '@material-ui/icons'
import { Button } from 'ui-components/Button'
import { DescItemList } from 'ui-components/DescItemList'
import { DescList } from 'ui-components/DescList'
import { Container } from './styles'

export default function ProductGroup({ group, onClick }) {
  const handleClick = () => {
    onClick(group)
  }

  return (
    <DescList>
      <Container>
        <DescItemList label="Nome">
          {group.attributes.name}
        </DescItemList>
        <Button buttonType="icon" onClick={handleClick}>
          <Edit />
        </Button>
      </Container>
    </DescList>
  )
}

ProductGroup.propTypes = {
  group: PropTypes.objectOf(PropTypes.any).isRequired,
  onClick: PropTypes.func.isRequired,
}
